import { NodeV2Style, safeParseBackground } from '@vedalib/editor'
import { css } from 'styled-components'

import { validateBoxShadowCss } from 'services/Branding/components/BrandFieldShadow/validateBoxShadowCss'

import { applyBackground, applyBlendMode } from '../formControls/BackgroundPicker/utils'
import { applyBorderImage } from '../formControls/BorderPicker/utils'
import { applyFilter } from '../formControls/Filter/utils'
import { applyPxSizes, applySizes, sumSizes } from '../formControls/Sizes/utils'
import type { INodeV2StyledProps } from './NodeV2Styled'

const BorderStyled = (style?: NodeV2Style | null) => {
  const border = safeParseBackground(style?.borderImage)
  if (!border || border.every(({ data }) => data.hide)) {
    return css`
      border-radius: ${applySizes(style?.borderRadius)};
    `
  }
  return css`
    border-radius: ${applySizes(style?.borderRadius)};
    ${border?.length === 1 && border[0].data.type === 'color' && !border[0].data.hide
      ? css`
          &:before {
            content: '';
            position: absolute;
            inset: 0px;
            padding: ${applyPxSizes(style?.padding)};
            border-style: ${style?.borderStyle};
            border-color: ${border[0].data.color};
            border-width: ${applyPxSizes(style?.borderWidth)};
            border-radius: ${applySizes(style?.borderRadius)};
            pointer-events: none;
          }
        `
      : css`
          &:before {
            content: '';
            position: absolute;
            inset: 0px;
            border-style: solid;
            border-color: transparent;
            background: ${applyBorderImage(style?.borderImage)} border-box;
            background-blend-mode: ${applyBlendMode(style?.borderImage)};
            border-width: ${applyPxSizes(style?.borderWidth)};
            border-radius: ${applySizes(style?.borderRadius)};
            background-origin: border-box;

            mask:
              linear-gradient(#fff 0 0) padding-box,
              linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
            pointer-events: none;
          }
        `}
  `
}

const ClipTextStyled = (style?: NodeV2Style | null) => {
  const clip = style?.backgroundClip
  return css`
    background-clip: ${clip};
    ${clip === 'text' &&
    css`
      & * {
        color: transparent !important;
        caret-color: black;
      }
    `}
  `
}

const BoxShadowStyled = (raw?: string | null) => {
  if (!raw) {
    return css`
      box-shadow: none;
    `
  }

  return css`
    box-shadow: ${validateBoxShadowCss(raw)};
  `
}

export const CommonStyled = ({ $style }: INodeV2StyledProps) => css`
  margin: ${applyPxSizes($style?.margin)};
  padding: ${applyPxSizes(sumSizes($style?.padding, $style?.borderWidth))};
  rotate: ${$style?.rotate || 0}deg;
  opacity: ${($style?.opacity ?? 100) / 100};

  backdrop-filter: ${applyFilter($style?.backdropFilter)};
  filter: ${applyFilter($style?.filter)};

  background: ${applyBackground($style?.background)};
  background-blend-mode: ${applyBlendMode($style?.background)};
  ${ClipTextStyled($style)};

  overflow: ${$style?.overflow};

  ${BorderStyled($style)};

  ${BoxShadowStyled($style?.boxShadow)};

  background-origin: border-box;
`
